import React, { Component } from 'react'
import { Switch } from 'react-router-dom'
import Form from './form'
import Grid from './grid'
import PrivateRoute from '../../containers/PrivateRoute'

class EquipamentoVirtual extends Component {
	render() {
		return (
			<div className="hdv-render-div">
				<div className="col-md-12 hdv-bloco-top-space hdv-zera-padding-left-right-boostrap">
					<Switch>
						<PrivateRoute path='/virtual/:imei/lancamento' component={Form} />
						<PrivateRoute path='/virtual/' component={Grid} />
					</Switch>
				</div>
			</div>
		)
	}
}

export default EquipamentoVirtual
